import IncidentTypesSettingsView from "@/components/features/settings/defaults/matter-types/MatterTypesSettingsView";

export default function IncidentTypesCard({
  title,
  addButtonLabel,
}: {
  title?: string;
  addButtonLabel?: string;
} = {}) {
  return (
    <IncidentTypesSettingsView title={title} addButtonLabel={addButtonLabel} />
  );
}
